import { render, staticRenderFns } from "./cModaladdConsignaciones.vue?vue&type=template&id=38eb63da"
import script from "./cModaladdConsignaciones.vue?vue&type=script&lang=js"
export * from "./cModaladdConsignaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports